import { render, staticRenderFns } from "./SelectClinicTemplate.vue?vue&type=template&id=62f21496&scoped=true&"
import script from "./SelectClinicTemplate.vue?vue&type=script&lang=ts&"
export * from "./SelectClinicTemplate.vue?vue&type=script&lang=ts&"
import style0 from "./SelectClinicTemplate.vue?vue&type=style&index=0&id=62f21496&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62f21496",
  null
  
)

export default component.exports